// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"2b5eb615","480":"ceff8616","838":"03ebab53"}[chunkId] + ".js";
};